// INSTALL: npm install socket.io-client  (run inside the frontend/ directory)

import { io } from 'socket.io-client';

// Strip the /api suffix — socket.io connects to the server root, not the API prefix
const SOCKET_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api')
    .replace(/\/api\/?$/, '');

// autoConnect: false — Header controls connect/disconnect explicitly
// so we never open a socket for unauthenticated visitors
const socket = io(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
});

export default socket;
